import PropTypes from 'prop-types'

import { ReactComponent as ActiveIcon } from './active.svg'
import { ReactComponent as Chevron } from './chevron.svg'
import styles from './ConversationRowTitle.module.scss'
import { ReactComponent as ResolvedIcon } from './resolved.svg'
import { ReactComponent as ReviewIcon } from './review.svg'
import { ReactComponent as SupportIcon } from './support.svg'
import { ReactComponent as WaitingIcon } from './waiting.svg'

const Icon = ({ chatCat }) => {
  switch (chatCat) {
    case 'AgentResponded':
      return <ActiveIcon />
    case 'ClientWaiting':
      return <WaitingIcon />
    case 'Rated':
      return <ReviewIcon />
    case 'Closed':
      return <ResolvedIcon />
    case 'StartedManually':
      return <ActiveIcon />
    case 'GdsBooking':
      return <SupportIcon />
    default:
      return null
  }
}

const ConversationRowTitle = ({
  title,
  count = 1,
  shouldShowCount,
  onClick,
  collapsed,
  collapsable,
  chatCat
}) => {
  if (!title) return null

  return (
    <div
      className={collapsable ? styles.collapsableContainer : styles.container}
      onClick={onClick}
    >
      <Icon chatCat={chatCat} />
      <span className={styles.title}>{title}</span>
      {count > 10 && shouldShowCount && <span className={styles.count}>{count}</span>}
      {collapsable && (
        <Chevron className={collapsed ? styles.chevronDown : styles.chevronUp} />
      )}
    </div>
  )
}

ConversationRowTitle.propTypes = {
  count: PropTypes.number,
  title: PropTypes.string.isRequired,
  shouldShowCount: PropTypes.bool
}

export default ConversationRowTitle
